/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";
import { diffYMDHMS, 
  convertToLocaleDate,
  getTimeZoneString,
formatDateToDDMMYYYY } from "../../utilities/dateUtilities";
import revealChosenChildCard from "../../images/chosen/single_reveal_child_card.svg";
import revealChosenFinoChildCard from "../../images/chosen/single_reveal_fino_child_card.svg";
import singleChosenChildCard from "../../images/chosen/single_chosen_child_card.svg";
import singleChosenFinoChildCard from "../../images/chosen/single_chosen_fino_child_card.svg";
import CelebrateIcon from "../../images/Project_Celebrate_icon.svg";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { SELECTED_SO_CODE_NZLO } from "../../constants/soCode";
import ImageCheck from "../atoms/ImageCheck";

const styles = {
  container: {
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: 1,
    position: "relative",
    top: "-41px",
    left: "-50%"
  },
  groupcontainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    zIndex: 0,
  },
  firstLeftcontainer: {
    width: 52,
    height: "fit-content",
    maxHeight: 75,
    borderRadius: 2,
    alignSelf: "center",
    position: "absolute",
    top: 13,
    right: -50,
    zIndex: 1, // works on ios
    transform: `rotate(${4.77}deg)`,
    objectFit: "cover",
  },
  firstRightcontainer: {
    width: 52,
    height: "fit-content",
    maxHeight: 75,
    borderRadius: 2,
    alignSelf: "center",
    position: "absolute",
    top: 13,
    left: -50,
    zIndex: 1, // works on ios
    transform: `rotate(${-4.77}deg)`,
    objectFit: "cover",
  },
  secondLeftcontainer: {
    width: 52,
    height: "fit-content",
    maxHeight: 75,
    borderRadius: 2,
    alignSelf: "center",
    position: "absolute",
    top: 23,
    right: -70,
    zIndex: 0, // works on ios
    transform: `rotate(${11.32}deg)`,
    objectFit: "cover",
  },
  secondRightcontainer: {
    width: 52,
    height: "fit-content",
    maxHeight: 75,
    borderRadius: 2,
    alignSelf: "center",
    position: "absolute",
    top: 23,
    left: -70,
    zIndex: 0, // works on ios
    transform: `rotate(${-11.32}deg)`,
  },
  leftcontainer: {
    width: 68,
    height: "fit-content",
    maxHeight: 75,
    borderRadius: 4,
    alignSelf: "center",
    position: "absolute",
  },
  rightcontainer: {
    width: 68,
    height: "fit-content",
    maxHeight: 75,
    alignSelf: "center",
    borderRadius: 4,
    objectFit: "cover",
  },
  centercontainer: {
    width: 58,
    height: "fit-content",
    maxHeight: 75,
    borderColor: "white",
    borderRadius: 4,
    alignSelf: "center",
    marginBottom: -10,
    zIndex: 2, // works on ios
    objectFit: "cover",
  },
  imgborderupdatestyle: {
    border: "2px solid #FF6B00"
  },
  imgborderstyle: {
    border: "2px solid white"
  },
  textcontainer: {
    position: "relative",
    borderRadius: 30,
    display: "flex",
    flexDirection: "column",
    maxWidth: 250,
    padding: "12px 15px 8px",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1,
  },
  textcontainerupdate: {
    backgroundColor: "#F66700",
  },
  textcontainernoupdate: {
    backgroundColor: "white",
  },
  inputstyle1: {
    color: "black",
    fontFamily: "Lato-Bold",
    fontSize: "14px",
    whiteSpace: "nowrap",
  },
  inputstyle2: {
    color: "black",
    marginTop: 2,
    fontFamily: "Lato",
    fontSize: "12px",
    textAlign: "center",
    width: "140px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    WebkitLineClamp: 2,
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
  },
  inputstyle1update: {
    color: "white",
    fontFamily: "Lato-Bold",
    fontSize: "14px",
  },
  inputstyle2update: {
    color: "white",
    marginTop: 2,
    fontFamily: "Lato",
    fontSize: "12px",
    textAlign: "center",
    width: "140px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    WebkitLineClamp: 2,
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
  },
  circleupdate: {
    position: "absolute",
    minWidth: 28,
    minHeight: 28,
    backgroundColor: "#FF6B00",
    borderRadius: "50%",
    border: "2px solid white",
    top: -14,
    right: -14,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Lato",
    fontWeight: 500,
    color: "#fff",
    fontSize: 14,
    padding: "3%",
    aspectRatio: "1/1"
  },
  celebrationIcon: {
    width: "20px",
    height: "20px"
  }
}

export default function GroupChildMarkerView(props) {
  const {isFino} = props;
 
  const { t } = useTranslation();
  const [momentOfRevealArr, setRevealMomentArr] = useState([]);
  const [revealTodayArr, setRevealTodayArr] = useState([]);
  const IsUpdateAvaialble = props?.groupData?.some((e) => e?.hasUpdate);
  const length = props?.groupData?.length;
  const [showCelebrationIcon, setShowCelebrationIcon] = useState(false);
  const { loginReducer , persistItemsReducer} = useSelector((state) => state);
  const regionNameTranslations = loginReducer?.getSOConfiguration?.regionNameTranslations || [];
  const { subRegionName } = props;
  const matchingTranslation = regionNameTranslations?.find(
  (entry) => entry?.region === subRegionName
  )?.translation;
  const region = matchingTranslation || subRegionName;
  useEffect(() => {
    // Defensive: clone array to avoid mutating props
    const updatedMomentOfRevealArr = [];
    const updatedRevealTodayArr = [];
    props?.groupData?.forEach(item => {
      if (item?.chosenCorrelationID) {
        const diffObj = diffYMDHMS(convertToLocaleDate(
          getTimeZoneString(
            item?.revealDate,
            persistItemsReducer?.selectedSOData?.soCode
          )), convertToLocaleDate());
        if (diffObj?.days < 0) {
          item.childImageURL = isFino ? revealChosenFinoChildCard : revealChosenChildCard;
          updatedMomentOfRevealArr.push(item?.chosenCorrelationID);
        } else if (diffObj?.days == 0) {
          item.childImageURL = isFino ? singleChosenFinoChildCard : singleChosenChildCard;
          updatedRevealTodayArr.push(item?.chosenCorrelationID);
        } else if (diffObj?.days > 0) {
          item.childImageURL = isFino ? singleChosenFinoChildCard : singleChosenChildCard;
        }
      }
    });
    setRevealMomentArr(updatedMomentOfRevealArr);
    setRevealTodayArr(updatedRevealTodayArr);
  }, [props?.groupData, isFino, persistItemsReducer?.selectedSOData?.soCode])

  useEffect(() => {
    props?.groupData?.forEach(item => {
      const today = new Date();
      const sponsorDate = new Date(item?.sponsorNotificationDate);
      const endDate = new Date(item?.apEstimatedEndDate);
      const isEligible = item?.isCelebrationEligible === true;
      if (sponsorDate.toString() !== "Invalid Date" &&
        endDate.toString() !== "Invalid Date" &&
        today >= sponsorDate &&
        today <= endDate &&
        isEligible) {
        setShowCelebrationIcon(true)
      }
    });
  }, [props?.groupData])


  const getChildName = () => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    if (props?.groupData) {
      if (momentOfRevealArr.length > 0 || revealTodayArr.length > 0) {
        if (momentOfRevealArr.length > 0) {
          return t("MeetYourChildren");
        }
        if (revealTodayArr.length > 0) {
          return t("RevealsToday", { noOfReveals: length });
        }
        return t("RevealsWithDate", { noOfReveals: length, 
          date: persistItemsReducer?.selectedSOData?.soCode === SELECTED_SO_CODE_NZLO ?
                      `${months[new Date(props?.groupData[0]?.revealDate).getMonth()]} ${new Date(props?.groupData[0]?.revealDate).getDate()}` : 
                      formatDateToDDMMYYYY(props?.groupData[0]?.revealDate)}
          
           );
      }
      return `${props?.groupData[0]?.childFirstName} +${length - 1} ${t("More")}`;
    }
    return null;
  };

  let totalUpdates = 0;
  props?.groupData?.map((item) => {
    totalUpdates = totalUpdates + (!item?.chosenCorrelationID ? item?.numberOfUpdates : 0);
  })

  const updateImage = showCelebrationIcon ? (
    <div style={styles.circleupdate}>
      <img src={CelebrateIcon} alt="Celebration" style={styles.celebrationIcon} />
    </div>
  ) : IsUpdateAvaialble && (
    <div style={styles.circleupdate}>{totalUpdates}</div>
  );

  const centerImageContainter = (child) => (
    <ImageCheck
      key={child.childCode}
      placeholderImage={1}
      imageUrl={child?.childImageURL}
      style={{
        ...styles.centercontainer,
        ...child?.hasUpdate ? styles.imgborderupdatestyle : styles.imgborderstyle,
        ...!child?.chosenCorrelationID ? {} : { border: "none" }
      }}
    />
  );

  const firstLeftImageContainter = (child) => (
    <ImageCheck
      key={child.childCode}
      placeholderImage={1}
      imageUrl={child?.childImageURL}
      style={{
        ...styles.firstLeftcontainer,
        ...child?.hasUpdate ? styles.imgborderupdatestyle : styles.imgborderstyle,
        ...!child?.chosenCorrelationID ? {} : { border: "none" }
      }}
    />
  );

  const firstRightImageContainter = (child) => (
    <ImageCheck
      key={child.childCode}
      placeholderImage={1}
      imageUrl={child?.childImageURL}
      style={{
        ...styles.firstRightcontainer,
        ...child?.hasUpdate ? styles.imgborderupdatestyle : styles.imgborderstyle,
        ...!child?.chosenCorrelationID ? {} : { border: "none" }
      }}
    />
  );

  const secondLeftImageContainter = (child) => (
    <ImageCheck
      key={child.childCode}
      placeholderImage={1}
      imageUrl={child?.childImageURL}
      style={{
        ...styles.secondLeftcontainer,
        ...child?.hasUpdate ? styles.imgborderupdatestyle : styles.imgborderstyle,
        ...!child?.chosenCorrelationID ? {} : { border: "none" }
      }}
    />
  );

  const secondRightImageContainter = (child) => (
    <ImageCheck
      key={child.childCode}
      placeholderImage={1}
      imageUrl={child?.childImageURL}
      style={{
        ...styles.secondRightcontainer,
        ...child?.hasUpdate ? styles.imgborderupdatestyle : styles.imgborderstyle,
        ...!child?.chosenCorrelationID ? {} : { border: "none" }
      }}
    />
  );

  const onLoadChilds = (child, index) => {
    if (index === 0) {
      return centerImageContainter(child);
    } if (index === 1) {
      return firstLeftImageContainter(child);
    } if (index === 2) {
      return firstRightImageContainter(child);
    } if (index === 3) {
      return secondLeftImageContainter(child);
    }
    return secondRightImageContainter(child);
  };

  return (
    <div style={styles.container}>
      <div style={styles.groupcontainer}>
        {props?.groupData?.map((child, index) => (
          <React.Fragment key={child.childCode || index}>
            {onLoadChilds(child, index)}
          </React.Fragment>
        ))}
      </div>
      <div
        style={{
          ...styles.textcontainer,
          ...IsUpdateAvaialble || momentOfRevealArr.length > 0 || props?.childValue?.isCelebration
            ? styles.textcontainerupdate
            : styles.textcontainernoupdate,
        }}
      >
        <span
          style={{
            ...styles.inputstyle1,
            ...IsUpdateAvaialble || momentOfRevealArr.length > 0 || props?.childValue?.isCelebration
              ? styles.inputstyle1update
              : styles.inputstyle1,
          }}
        >
          {getChildName()}
        </span>
        <div
          style={{
            ...styles.inputstyle2,
            ...IsUpdateAvaialble || momentOfRevealArr.length > 0 || props?.childValue?.isCelebration
              ? styles.inputstyle2update
              : styles.inputstyle2,
          }}
        >
          {region}
        </div>
        {updateImage}
      </div>
    </div>
  );
}
